<app-modal [title]="'Asociar nuevo servicio'">
    <app-form [formGroup]="saveForm">
      <div class="mb-5">
        <app-label for="param_servicio_id">
          Servicio
        </app-label>
        <app-select id="param_servicio_id" formControlName="param_servicio_id" placeholder="Seleccione un servicio" [options]="serviciosOptions" />
      </div>
    </app-form>

    <app-creation-buttons *hasPermission="'prospectos:create'"
      [valid]="saveForm.valid"
      [process]="loading"
      (onCreateClick)="create()"
      (onCancelClick)="cancel()"
    />
</app-modal>
